<template>
  <div class="pager">
        
        <a class="button white" v-if="currentItems < totalItems" @click="onClick" :title="labels.showMore" role="button" tabindex="0">{{labels.showMore}}</a>
        <div class="stretch"></div>
      </div>
</template>

<script>
import { Labels } from '../services/labels.js'

export default {
  name: 'Pager',
  props: [
    "totalItems",
    "currentItems",
    "click"
  ],
  data() {
      return {
          labels: Labels
      }
  },
  methods: {
      onClick () {
          this.$emit("click");
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pager {
  display: flex;
  flex-direction: row;
  margin-top: 16px;
}

.stretch {
  flex-grow: 1;
}

.pager .more-link:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 13px;
    height: 14px;
    margin-top: -8px;
    margin-left: 1px;
    margin-right: 10px;
    background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='utf-8'?%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 10 6'%3E%3Cpath fill='%232655FF' d='M9.5,0.2C9.4,0.1,9.2,0.1,9.1,0.1C9,0.1,8.8,0.1,8.7,0.2L5,3.9L1.3,0.2C1.2,0.1,1,0.1,0.9,0.1S0.6,0.1,0.5,0.2 L0.2,0.5C0,0.8,0,1.1,0.2,1.3l4.4,4.4C4.7,5.9,4.9,5.9,5,5.9h0c0.1,0,0.3-0.1,0.4-0.2l4.4-4.4C9.9,1.2,10,1.1,10,0.9 c0-0.1-0.1-0.3-0.2-0.4L9.5,0.2z M5,5.8L5,5.8L5,5.8L5,5.8z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 0px 3px;
}

.pager .more-link {
    position: relative;
    display: inline;
    padding: 10px 0 10px 25px;
    font-family: 'Gotham SSm A','Gotham SSm B',sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    color: #000;
    cursor: pointer;
}

</style>